import { Box, Typography, Divider } from '@material-ui/core';
import appConfig from '../../../../../app-config';

import React, { Fragment } from 'react';
import styled from 'styled-components';

const DistanceSpan = styled.span`
  color: ${(props) => props.theme.secondaryColorPlainText};
`;

const LocationCustomFormatLabel = ({
  location,
  coords,
  interPickUpDetails,
  displayAddress = false,
  isLastLocation = false,
}) => {
  const { accepting_orders, name, distance, is_order_ahead_enabled } = location;

  if (interPickUpDetails && location.id === interPickUpDetails.id) {
    location.isNearestLocation = interPickUpDetails.isNearestLocation;
  }

  return (
    <Fragment>
      <Box
        component={'div'}
        display={'flex'}
        flexDirection={'column'}
        position='relative'
      >
        <Box>
          {(!accepting_orders || !is_order_ahead_enabled) && (
            <span>💤 Closed - </span>
          )}
          <span>
            {name} {coords && '- '}
          </span>
          {coords && <DistanceSpan>{distance}</DistanceSpan>}
          {location.isNearestLocation && <span> - (Nearest Location)</span>}
        </Box>
        {!appConfig.isPickupAddressSelectionDisabled && displayAddress && (
          <>
            <Typography
              component={'div'}
              variant='caption'
              color='textSecondary'
            >
              <span>{location?.line1}</span>
              <span>, </span> <span>{location?.city}</span>
            </Typography>
            {!isLastLocation && (
              <Divider
                variant='fullWidth'
                style={{
                  position: 'absolute',
                  bottom: '-8px',
                  left: 0,
                  right: 0,
                  backgroundColor: appConfig.styleConfig.primaryColor,
                }}
              />
            )}
          </>
        )}
      </Box>
    </Fragment>
  );
};

export default LocationCustomFormatLabel;
